import { component } from "picoapp";
import "slick-carousel";
import $ from "jquery";

export default component((node) => {
  const $mobileCarousel = $(node).find(".mobile-recommended-products");
  $mobileCarousel.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    prevArrow: $(".other-product-arrow-prev"),
    nextArrow: $(".other-product-arrow-next"),
  });
});
